import React, { useState, useCallback, KeyboardEvent } from 'react';
import { Box, TextField, MenuItem, Select, FormControl, InputLabel, InputAdornment, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { CONTACT_TYPE_OPTIONS } from '../availability-schedules.model';

interface CalendarFilterBarProps {
  onFilterChange: (filters: { search?: string; contact_type?: string }) => void;
}

const CalendarFilterBar: React.FC<CalendarFilterBarProps> = ({ onFilterChange }) => {
  const [search, setSearch] = useState('');
  const [submittedSearch, setSubmittedSearch] = useState('');
  const [contactType, setContactType] = useState('');

  const emitFilters = useCallback(
    (newSearch: string, newContactType: string) => {
      const filters: { search?: string; contact_type?: string } = {};
      if (newSearch) filters.search = newSearch;
      if (newContactType) filters.contact_type = newContactType;
      onFilterChange(filters);
    },
    [onFilterChange],
  );

  const handleSearchSubmit = () => {
    setSubmittedSearch(search);
    emitFilters(search, contactType);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearchSubmit();
    }
  };

  const handleContactTypeChange = (e: any) => {
    const value = e.target.value;
    setContactType(value);
    // Use submittedSearch (not in-progress search) to avoid leaking unsubmitted text
    emitFilters(submittedSearch, value);
  };

  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center' }}>
      <TextField
        size="small"
        placeholder="Search provider by name..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={handleKeyDown}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton size="small" onClick={handleSearchSubmit} aria-label="search">
                <SearchIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{ minWidth: 250 }}
      />
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel id="contact-type-label">Contact Type</InputLabel>
        <Select
          labelId="contact-type-label"
          value={contactType}
          label="Contact Type"
          onChange={handleContactTypeChange}
        >
          {CONTACT_TYPE_OPTIONS.map((opt) => (
            <MenuItem key={opt.id} value={opt.id}>
              {opt.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default CalendarFilterBar;
